var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFDED2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.5C19.66 28.5 17.75 26.59 17.75 24.25C17.75 23.84 18.09 23.5 18.5 23.5C18.91 23.5 19.25 23.84 19.25 24.25C19.25 25.77 20.48 27 22 27C23.52 27 24.75 25.77 24.75 24.25C24.75 23.84 25.09 23.5 25.5 23.5C25.91 23.5 26.25 23.84 26.25 24.25C26.25 26.59 24.34 28.5 22 28.5Z",
    fill: "#FF9871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.19 16.3799C15 16.3799 14.8 16.2999 14.66 16.1599C14.37 15.8699 14.37 15.3899 14.66 15.0999L18.29 11.4699C18.58 11.1799 19.06 11.1799 19.35 11.4699C19.64 11.7599 19.64 12.2399 19.35 12.5299L15.72 16.1599C15.57 16.2999 15.38 16.3799 15.19 16.3799Z",
    fill: "#FF9871"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.81 16.3799C28.62 16.3799 28.43 16.3099 28.28 16.1599L24.65 12.5299C24.36 12.2399 24.36 11.7599 24.65 11.4699C24.94 11.1799 25.42 11.1799 25.71 11.4699L29.34 15.0999C29.63 15.3899 29.63 15.8699 29.34 16.1599C29.2 16.2999 29 16.3799 28.81 16.3799Z",
    fill: "#FF9871"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.21 20.6001C30.14 20.6001 30.07 20.6001 30 20.6001H29.77H14C13.3 20.6101 12.5 20.6101 11.92 20.0301C11.46 19.5801 11.25 18.8801 11.25 17.8501C11.25 15.1001 13.26 15.1001 14.22 15.1001H29.78C30.74 15.1001 32.75 15.1001 32.75 17.8501C32.75 18.8901 32.54 19.5801 32.08 20.0301C31.56 20.5501 30.86 20.6001 30.21 20.6001ZM14.22 19.1001H30.01C30.46 19.1101 30.88 19.1101 31.02 18.9701C31.09 18.9001 31.24 18.6601 31.24 17.8501C31.24 16.7201 30.96 16.6001 29.77 16.6001H14.22C13.03 16.6001 12.75 16.7201 12.75 17.8501C12.75 18.6601 12.91 18.9001 12.97 18.9701C13.11 19.1001 13.54 19.1001 13.98 19.1001H14.22Z",
    fill: "#FF9871"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.89 32.7502H18.86C15.28 32.7502 14.48 30.6202 14.17 28.7702L12.76 20.1202C12.69 19.7102 12.97 19.3302 13.38 19.2602C13.78 19.1902 14.17 19.4702 14.24 19.8802L15.65 28.5202C15.94 30.2902 16.54 31.2502 18.86 31.2502H24.89C27.46 31.2502 27.75 30.3502 28.08 28.6102L29.76 19.8602C29.84 19.4502 30.23 19.1802 30.64 19.2702C31.05 19.3502 31.31 19.7402 31.23 20.1502L29.55 28.9002C29.16 30.9302 28.51 32.7502 24.89 32.7502Z",
    fill: "#FF9871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcart);
export default __webpack_public_path__ + "static/media/acart.8b283e8e60f73c3de5d8621cac191aa5.svg";
export { ForwardRef as ReactComponent };